import { IconButton } from '@sweep-io/sweep-design';
import { Search } from '@sweep-io/sweep-design/dist/icons';
import { useSearchContext } from './SearchContext';
import { useFeatureToggle } from '../../../../feature-flags/useFeatureToggle';

export const DependenciesSearchEntryIcon = () => {
  const { searchInDocumentationCard } = useFeatureToggle();
  const { isInputVisible, setIsInputVisible } = useSearchContext();

  if (!searchInDocumentationCard || isInputVisible) {
    return null;
  }

  return (
    <IconButton
      disabled={isInputVisible}
      onClick={() => setIsInputVisible(true)}
      variant="flat"
      size="tiny"
    >
      <Search />
    </IconButton>
  );
};
